import api from '@/api/'

export const title = {
  Add: '添加分类',
  Edit: '编辑分类'
}

export const strategyCommand = {
  edit(data) {
    this.title = title.Edit
    this.visible = true
    this.isEdit = true
    this.waitItem = data
    const { type_name, parent, path, name, title: titleD, keywords, description, is_show, sort } = data
    const cascader = parent ? path.split('-').map(o => Number(o)).slice(1, -1) : [0]
    this.$nextTick(() => {
      this.form.setFieldsValue({
        cascader,
        type_name, name, title: titleD, keywords,
        description, is_show: Number(is_show), sort: sort
      })
    })
  },
  add(data) {
    this.isEdit = false
    this.visible = true
    this.title = title.Add
    const { path } = data
    const cascader = path.split('-').slice(1).map(o => Number(o))
    this.$nextTick(() => {
      this.form.setFieldsValue({
        cascader
      })
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteClassify({ path: data.path })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
